// Global packages and components
import { Link } from '@remix-run/react'
import { ArrowRightIcon } from '@heroicons/react/24/outline'
import {
  BannerImage,
  SchemaElement,
  SchemaMeta,
  SchemaWrapper,
} from '~/components'

// Types
import type { CustomCategoryProps } from '~/types'

interface BlockCategoryGridProps {
  items: CustomCategoryProps[]
}

// Main export
export default function BlockCategoryGrid({ items }: BlockCategoryGridProps) {
  return (
    <SchemaWrapper
      className="container"
      type="ItemList"
    >
      <SchemaMeta
        prop="name"
        content="Category grid"
      />
      <div className="grid grid-cols-2 gap-4 md:gap-8 lg:grid-cols-3">
        {items &&
          items.map((e, i) => {
            const to = `/${e?.type}/c/${e?.slug?.current}`
            return (
              <SchemaWrapper
                key={i}
                className="group relative aspect-not-square overflow-hidden rounded-2xl"
                prop="itemListElement"
                type="ListItem"
              >
                <SchemaMeta
                  prop="position"
                  content={String(i + 1)}
                />
                <SchemaWrapper
                  as={Link}
                  to={to}
                  className="block size-full"
                  prop="item"
                  type="OfferCatalog"
                >
                  <SchemaElement
                    as="link"
                    prop="url"
                    href={to}
                  />
                  {e?.title && (
                    <div className="absolute left-0 top-0 z-[2] flex h-full w-full flex-col items-start justify-end px-4 py-3 text-white md:py-5">
                      <div className="flex w-full items-center justify-between">
                        <h4 className="mb-0 text-left text-base font-semibold transition-colors group-hover:text-vibrant-green md:text-xl">
                          <SchemaElement prop="name">{e.title}</SchemaElement>
                        </h4>
                        <div className="ml-3 hidden size-7 items-center justify-center rounded-full bg-vibrant-green md:flex">
                          <ArrowRightIcon className="size-4 text-forest-green" />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="absolute left-0 top-0 size-full transition-transform group-hover:scale-105">
                    {e?.image?.asset && (
                      <BannerImage
                        image={e.image}
                        absolute={false}
                        size={768}
                      />
                    )}
                  </div>
                </SchemaWrapper>
              </SchemaWrapper>
            )
          })}
      </div>
    </SchemaWrapper>
  )
}
